// Simple encoding to hide the word (not cryptographically secure, just obscured)
export function encodeWord(word) {
  // Shift each letter by 13 (ROT13) then base64
  const shifted = word.split('').map(char => {
    const code = char.charCodeAt(0);
    if (code >= 65 && code <= 90) { // Uppercase
      return String.fromCharCode(((code - 65 + 13) % 26) + 65);
    }
    return char;
  }).join('');
  return btoa(shifted);
}

export function decodeWord(encoded) {
  try {
    const shifted = atob(encoded);
    // Reverse the ROT13
    return shifted.split('').map(char => {
      const code = char.charCodeAt(0);
      if (code >= 65 && code <= 90) {
        return String.fromCharCode(((code - 65 + 13) % 26) + 65);
      }
      return char;
    }).join('');
  } catch {
    return null;
  }
}
